import BTN_R_PAY from './btn_r_pay.gif';
import BTN_PAY_PAY from './btn_paypay.png';

export const BTN_R_PAY_IMG_PATH = BTN_R_PAY.toString();
export const BTN_PAY_PAY_PATH = BTN_PAY_PAY.toString();
